import PropTypes from 'prop-types';

import ListItem from '../../../components/ListItem';

const FnolCategoryItem = ({ fnolCategory, onClick }) => {
  const handleClick = () => onClick(fnolCategory.key);

  return (
    <ListItem onClick={handleClick}>
      <h4>{fnolCategory.name}</h4>
    </ListItem>
  );
};

FnolCategoryItem.propTypes = {
  fnolCategory: PropTypes.shape({
    key: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default FnolCategoryItem;
